
import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action } from 'vuex-class';

import { getToken } from '@/functions/token.function';

import { User } from '@/models/user.types';

import ModalTermConditionComponent from '@/components/signup/ModalTermCondition.vue';

@Component({
  components: {
    ModalTermConditionComponent,
  },
})
export default class Signup extends Vue {
  /* VUEX */

  // ACTIONS
  @Action('authLayout')
  private authLayout: any;
  @Action('actionSignup', { namespace: 'user' })
  private actionSignup: any;
  @Action('actionResetUser', { namespace: 'user' })
  private actionResetUser: any;

  // STATE
  @State('user')
  private user: User;

  /* INITIALIZATION */

  private showTermCondition: boolean = false;
  private agree: boolean = false;

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.authLayout();

    if (getToken()) {
      this.$router.push({ name: 'dashboard' });
    }
  }

  private mounted() {
    this.actionResetUser();
    this.$emit(
      'updateTitle',
      'Buat situs web  <span class="bold d-block">Pusat Karir Sekolah',
      'Mengelola pusat karir sekolah #JadiMudah',
    );
  }

  /* METHODS */
  private actionPage(routeName: string) {
    this.$router.push({ name: routeName });
  }

  private actionPortal(portalName: string) {
    if (portalName === 'candidate') {
      window.open('https://career.support/candidate/#/signin', '_blank');
    } else {
      window.open('https://company.career.support/', '_blank');
    }
  }
}
